import { CoreApi, LightSelectionSystem } from '@inter-ikea-storageone/range';
import { Feature } from '../../../features/Feature';

export class LightsSelection extends Feature {
  protected init(coreApi: CoreApi): void {
    coreApi.registerSystem(new LightSelectionSystem(coreApi));
  }
}
